// Typeface
var typeface = {
  typefaceBase: '"Allstate Sans", "Arial", "Helvetica", sans-serif',
  typefaceAlt: '"Georgia", serif',
  typefaceMonospace: '"Courier", monospace'
};
export default typeface;